import { createStore, mapGetters } from 'vuex';
import user from './modules/user';
/***配置vue+ts的项目里面使用vuex
 * declare module '@vue/runtime-core'{
 *  interface State{
 *    count:number,
 *    list:string[],
 *    msg:string
 *  }
 *  interface ComponentCustomProperties{
 *    $store: Store<State>
 *  }
 * }
 *
 *
 */
const language = (navigator.language || 'en').toLocaleLowerCase(); // 这是获取浏览器的语言
const languageMap = {
  'zh-cn': 'zh',
  'zh-tw': 'zhTw',
  // 添加其他语言的映射
};

const local = languageMap[language] || 'en';

export default createStore({
  state: {
    // 数据
    msg: '你好vue3',
    language: sessionStorage.getItem('language') || local,
    BreadCrumb: JSON.parse(sessionStorage.getItem('BreadCrumb')) || [],
    token: JSON.parse(sessionStorage.getItem('token')) || '',
    loginStatus: JSON.parse(sessionStorage.getItem('loginStatus')) || false,
    organizationInfo: JSON.parse(sessionStorage.getItem('organizationInfo')) || {},
    MonitoringType: [
      { value: 1, label: '废水' },
      { value: 2, label: '废气' },
      { value: 3, label: '噪声' },
      { value: 4, label: '地下水' },
      { value: 5, label: '土壤' },
      { value: 6, label: '一般固废' },
      { value: 7, label: '危废' },
    ],
    // 碳管家
    // 数据
    userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || '',
    nowClientWidth: '',
    orgInfo: JSON.parse(sessionStorage.getItem('orgInfo')) || '',
    upLoadProgress: 0,
    downLoadProgress: 0,
    generatePDFProgress: 0,
    fileName: [],
    pollutantTypeOptions: [
      // 没有固废危废的监测类型
      { value: 1, label: '废水' },
      { value: 2, label: '废气' },
      { value: 3, label: '噪声' },
      { value: 4, label: '地下水' },
      { value: 5, label: '土壤' },
    ],
    alarmMonitoringType: [
      // 告警设置--监测类型
      { value: 1, label: '废水' },
      { value: 2, label: '废气' },
    ],
    pointType: [
      // 监测点类型
      { value: 1, label: '主要排放口' },
      { value: 2, label: '一般排放口' },
    ],
    modeType: [
      // 监测方式类型
      { value: 0, label: '手动' },
      { value: 1, label: '自动' },
    ],
    taskStatus: [
      // 任务状态 1-待下发；2-待分发；3-处理中；4-已超时
      { value: 1, label: '待下发' },
      { value: 2, label: '待分发' },
      { value: 3, label: '处理中' },
      { value: 4, label: '已超时' },
      { value: 5, label: '已完成' },
    ],
    fillTaskStatus: [
      // 填报任务状态 1-待下发（保存）；2-待分发（下发后）；3-处理中（分发后）；4-已超时；5-待法人主管审核；6-待事业群审核；7-一次填报完成
      { value: 1, label: '待下发' },
      { value: 2, label: '待分发' },
      { value: 3, label: '处理中' },
      { value: 4, label: '已超时' },
      { value: 5, label: '待法人主管审核' },
      { value: 6, label: '待事业群审核' },
      { value: 7, label: '一次填报完成' },
    ],
    taskFlowStatus: [
      // 任务流程-状态 1，待下发，2，待分发，3，处理中，4，已超时，5，待审核，6，主管审核通过，7，事业群审核通过
      { value: 1, label: '待下发' },
      { value: 2, label: '待分发' },
      { value: 3, label: '处理中' },
      { value: 4, label: '已超时' },
      { value: 5, label: '待审核' },
      { value: 6, label: '主管审核通过' },
      { value: 7, label: '事业群审核通过' },
    ],
    disposalMethodList: [
      // 委外处置方式 1-回用;2-回收;3-生物燃料;4-堆肥;5-厌氧消化;6-焚烧转化能源（WtE）;7-焚烧无能量转化;8-垃圾填埋;9-待定TBD;10-强制管控废物;11-可降低碳排放的WtE
      { value: 1, label: '回用' },
      { value: 2, label: '回收' },
      { value: 3, label: '生物燃料' },
      { value: 4, label: '堆肥' },
      { value: 5, label: '厌氧消化' },
      { value: 6, label: '焚烧转化能源（WtE）' },
      { value: 7, label: '焚烧无能量转化' },
      { value: 8, label: '垃圾填埋' },
      { value: 9, label: '待定TBD' },
      { value: 10, label: '强制管控废物' },
      { value: 11, label: '可降低碳排放的WtE' },
    ],
    fillingTypeList: [
      // 填报类型
      { value: 1, label: '年报' },
      { value: 2, label: '月报' },
    ],
    alarmPankList: [
      // 告警级别
      { value: 0, label: '紧急' },
      { value: 1, label: '重要' },
      { value: 2, label: '一般' },
    ],
    alarmTypeList: [
      // 告警类型
      { value: 1, label: '日均值告警' },
      { value: 2, label: '小时均值告警' },
    ],
    alarmStatusList: [
      // 告警状态
      { value: 0, label: '未分配' },
      { value: 1, label: '未处理' },
      { value: 2, label: '已处理' },
    ],
    alarmSetUpStatusList: [
      // 告警设置 告警状态
      { value: 0, label: '状态' },
      { value: true, label: '启用' },
      { value: false, label: '未启用' },
    ],
    isTrueOrFalse: [
      // 是否
      { value: 0, label: '否' },
      { value: 1, label: '是' },
    ],
    buTypeList: [
      // 业务类型
      { value: 0, label: '申领' },
      { value: 1, label: '登记' },
      { value: 2, label: '变更' },
    ],
    PEIAStatusList: [
      // 环保档案-项目环评-状态
      { value: 1, label: '拟建设中' },
      { value: 2, label: '建设中' },
      { value: 3, label: '竣工调试' },
      { value: 4, label: '已验收' },
      { value: 5, label: '已取消' },
    ],
    PEIAProjectTypeList: [
      // 环保档案-项目环评-项目类型
      { value: 1, label: '报告书' },
      { value: 2, label: '报告表' },
      { value: 3, label: '登记表' },
    ],
    PreplanTypeList: [
      // 环保档案-应急预案-预案类型
      { value: 1, label: '环境应急预案' },
      { value: 2, label: '重污染天气应急管控' },
      { value: 3, label: '环境风险应急预案备案表' },
    ],
    HonorTypeList: [
      // 环保档案-环保荣誉-证书类型
      { value: 1, label: 'ISO14001' },
      { value: 2, label: 'ISO50001' },
      { value: 3, label: 'ISO14064' },
      { value: 4, label: '环保信用等级' },
      { value: 5, label: 'UL2799' },
      { value: 6, label: '绿色工厂' },
      { value: 7, label: '绿色供应链' },
      { value: 8, label: '绿色建筑/LEED' },
      { value: 9, label: '近零碳项目' },
      { value: 10, label: '清洁生产-自愿' },
      { value: 11, label: '清洁生产-强制' },
      { value: 12, label: '能效领跑者' },
      { value: 13, label: '水效领跑者' },
      { value: 14, label: '产品环保/节能认证' },
      { value: 15, label: '其他' },
    ],
    solidWasteTypeList: [
      // 固废名录
      {
        value: '311-001-01',
        label: '烧结烟尘灰',
        type: 'SW01冶炼废渣',
        from: '炼铁',
      },
      {
        value: '311-002-01',
        label: '高炉渣',
        type: 'SW01冶炼废渣',
        from: '炼铁',
      },
      {
        value: '311-003-01',
        label: '高炉瓦斯泥',
        type: 'SW01冶炼废渣',
        from: '炼铁',
      },
    ],
    dangerWasteTypeList: [
      // 危废名录
      {
        value: '841-001-01',
        label: '感染性废物 ',
        type: 'HW01医疗废物',
        from: '卫生',
      },
      {
        value: '841-002-01',
        label: '损伤性废物  ',
        type: 'HW01医疗废物',
        from: '卫生',
      },
      {
        value: '841-003-01',
        label: '病理性废物  ',
        type: 'HW01医疗废物',
        from: '卫生',
      },
    ],
  },
  getters: {
    // 计算属性
    // 访问getter的方法有：1）store.getters.Mcode  2）this.$store.getters.Mcode
    // 3）通过mapGetters辅助函数
    // import { mapGetters } from 'vuex
    // 使用对象展开运算符将 getter 混入 computed 对象中
    // ...mapGetters([
    //   'Mcode',
    //   'user'
    // ])
    // reverseMsg(state){
    //   return state.msg.split("").reverse().join("")
    // }
  },
  mutations: {
    // 方法  可以写，但是报错，没意义
    changeMsg(state, Msg) {
      state.msg = Msg;
    },
    changeBreadCrumb(state, BreadCrumb) {
      state.BreadCrumb = BreadCrumb;
      sessionStorage.setItem('BreadCrumb', JSON.stringify(BreadCrumb));
    },
    changeLanguage(state, language) {
      state.language = language;
      sessionStorage.setItem('language', language);
    },
    changeToken(state, token) {
      state.token = token;
      sessionStorage.setItem('token', JSON.stringify(token));
    },
    changeLoginStatus(state, loginStatus) {
      state.loginStatus = loginStatus;
      sessionStorage.setItem('loginStatus', JSON.stringify(loginStatus));
    },
    changeOrganizationInfo(state, organizationInfo) {
      // 历史遗留问题，多个同步更新
      state.organizationInfo = organizationInfo;
      sessionStorage.setItem('organizationInfo', JSON.stringify(organizationInfo));
      state.orgInfo = organizationInfo;
      sessionStorage.setItem('orgInfo', JSON.stringify(organizationInfo));
      state.userInfo = { ...state.userInfo, ...organizationInfo };
      sessionStorage.setItem('userInfo', JSON.stringify(state.userInfo));
    },
    // 方法  可以写，但是报错，没意义
    changeNowClientWidth(state, nowClientWidth) {
      state.nowClientWidth = nowClientWidth;
    },
    changeUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    changeOrgInfo(state, orgInfo) {
      state.orgInfo = orgInfo;
      sessionStorage.setItem('orgInfo', JSON.stringify(orgInfo));
    },
    changeUpLoadProgress(state, upLoadProgress) {
      state.upLoadProgress = upLoadProgress;
    },
    changeDownLoadProgress(state, downLoadProgress) {
      state.downLoadProgress = downLoadProgress;
    },
    changeGeneratePDFProgress(state, generatePDFProgress) {
      state.generatePDFProgress = generatePDFProgress;
    },
    changeFileName(state, fileName) {
      state.fileName = fileName;
    },
  },
  actions: {
    // 执行一些 异步操作 主要用于执行 mutations里面的方法
    // changeMcode(codes, relcode){ // 用dispatch方法调用  store.dispatch('changeMcode')
    //   codes.commit("changeMcode", relcode) // 执行mutations里面的changeMcode方法
    // },
  },
  modules: {
    // 模块
    user: user,
  },
});
